import { ReactElement } from 'react';
import { Badge, BadgeProps } from '@fluentui/react-components';
import {
  CheckmarkCircleRegular,
  ClipboardTaskRegular,
  DismissCircleRegular,
  EditRegular,
  RocketRegular,
  SendClockRegular,
  TaskListSquareLtrRegular,
} from '@fluentui/react-icons';

import { CHANGE_STATUS, TChangeStatus } from '../../models';

// Status is conveyed with both an icon and text, never color alone.
const STATUS_META: Record<TChangeStatus, { color: BadgeProps['color']; icon: ReactElement }> = {
  [CHANGE_STATUS.DRAFT]: { color: 'informative', icon: <EditRegular /> },
  [CHANGE_STATUS.SUBMITTED]: { color: 'warning', icon: <SendClockRegular /> },
  [CHANGE_STATUS.IN_ASSESSMENT]: { color: 'brand', icon: <ClipboardTaskRegular /> },
  [CHANGE_STATUS.INITIAL_PLANNING]: { color: 'brand', icon: <TaskListSquareLtrRegular /> },
  [CHANGE_STATUS.IN_EXECUTION]: { color: 'brand', icon: <RocketRegular /> },
  [CHANGE_STATUS.IN_COMPLETION]: { color: 'brand', icon: <CheckmarkCircleRegular /> },
  [CHANGE_STATUS.CLOSED]: { color: 'success', icon: <CheckmarkCircleRegular /> },
  [CHANGE_STATUS.CANCELLED]: { color: 'danger', icon: <DismissCircleRegular /> },
};

type TProps = {
  status: TChangeStatus;
  size?: BadgeProps['size'];
  className?: string;
};

export const StatusBadge = ({ status, size = 'large', className }: TProps) => {
  const meta = STATUS_META[status] ?? { color: 'subtle', icon: undefined };
  return (
    <Badge appearance="tint" color={meta.color} size={size} icon={meta.icon} className={className}>
      {status}
    </Badge>
  );
};
